import { defineStore } from 'pinia';
import { userService } from '@/services/modules/user';
import type { LoginDTO, RegisterDTO } from '@/types';

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    username: '',
  }),
  getters: {
    isAuthenticated: (state) => {
      // 每次获取认证状态时都检查localStorage中的token是否发生变化
      const tokenFromStorage = localStorage.getItem('token') || '';
      if (state.token !== tokenFromStorage) {
        state.token = tokenFromStorage;
      }
      return !!state.token;
    }
  },
  actions: {
    async login(loginData: LoginDTO) {
      try {
        const response = await userService.login(loginData);
        if (response.code === 200) {
          this.token = response.data;
          localStorage.setItem('token', response.data);
          console.log('用户登录成功，token已设置:', response.data);
          return true;
        }
        return false;
      } catch (error) {
        console.error('登录失败:', error);
        return false;
      }
    },
    async register(registerData: RegisterDTO) {
      try {
        const response = await userService.register(registerData);
        if (response.code === 200) {
          return true;
        } else {
          // 抛出特定错误
          if (response.code === 400) {
            throw new Error('USERNAME_EXISTS');
          } else {
            throw new Error(`注册失败，状态码: ${response.code}`);
          }
        }
      } catch (error: any) {
        console.error('注册失败:', error);
        if (error.message === 'USERNAME_EXISTS') {
          throw error; // 重新抛出特定错误
        }
        return false;
      }
    },
    logout() {
      console.log('用户登出，清除token');
      this.token = '';
      localStorage.removeItem('token');
    }
  }
});